import type { FieldDef } from "../types";
import { Icon } from "./Icon";

interface Props {
  fieldKey: string;
  def: FieldDef;
  copiedKey: string | null;
  onCopy: (key: string, value: string, label: string) => void;
  ssnRevealed?: boolean;
  onToggleSsn?: () => void;
}

export function FieldRow({ fieldKey, def, copiedKey, onCopy, ssnRevealed, onToggleSsn }: Props) {
  const sensitive = def.sensitive;
  const display = sensitive && !ssnRevealed ? "•••-••-••••" : def.value;
  const isCopied = copiedKey === fieldKey;

  return (
    <button
      type="button"
      onClick={() => onCopy(fieldKey, def.copyValue ?? def.value, def.label)}
      className={`field-row ${isCopied ? "is-copied" : ""}`}
    >
      <span className="field-row__meta">
        <span className="field-row__label">{def.label}</span>
        {def.hint && <span className="field-row__hint">{def.hint}</span>}
      </span>
      <span className="field-row__value-wrap">
        <span className={`field-row__value ${sensitive ? "field-row__value--mono" : ""}`}>
          {display}
        </span>
        {sensitive && onToggleSsn && (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              onToggleSsn();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.stopPropagation();
                e.preventDefault();
                onToggleSsn();
              }
            }}
            className="field-row__eye"
            aria-label={ssnRevealed ? "Hide SSN" : "Reveal SSN"}
          >
            {ssnRevealed ? <Icon.EyeOff width={14} height={14} /> : <Icon.Eye width={14} height={14} />}
          </span>
        )}
        <span className="field-row__copy">
          {isCopied ? (
            <>
              <Icon.Check width={13} height={13} />
              <span>Copied</span>
            </>
          ) : (
            <>
              <Icon.Copy width={13} height={13} />
              <span>Copy</span>
            </>
          )}
        </span>
      </span>
    </button>
  );
}
